// QR code generator (canvas render + PNG download).
import qrcodeLib from "qrcode-generator";
import { el, btn, ta, sel, wrap, download } from "./ui.js";

export function qrcode(root) {
	const s = wrap(root); s.classList.add("rv-qr");
	const text = ta({ placeholder: "Enter text or a URL…" }); text.classList.add("rv-qr-input");
	text.setAttribute("aria-label", "Text or link for the QR code");
	text.value = "https://";
	const ec = sel([["L", "Low"], ["M", "Medium"], ["Q", "Quartile"], ["H", "High"]], "M");
	ec.id = "rv-qr-ec";
	const canvas = el("canvas", "rv-qr-canvas");
	canvas.setAttribute("role", "img");
	const dlBtn = btn("Download PNG", () => { if (canvas.width) download("qrcode.png", canvas.toDataURL("image/png")); }, "rv-tbtn");
	const errEl = el("p", "rv-tnote", "");
	errEl.setAttribute("role", "alert");

	function generate() {
		const v = text.value.trim();
		const ctx = canvas.getContext("2d");
		errEl.textContent = "";
		if (!v) { canvas.width = canvas.height = 0; return; }
		try {
			const qr = qrcodeLib(0, ec.value);
			qr.addData(v); qr.make();
			const n = qr.getModuleCount();
			const cell = 8, margin = 4 * cell;
			const size = n * cell + margin * 2;
			canvas.width = size; canvas.height = size;
			ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, size, size);
			ctx.fillStyle = "#000000";
			for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (qr.isDark(r, c)) ctx.fillRect(margin + c * cell, margin + r * cell, cell, cell);
			canvas.setAttribute("aria-label", "QR code for " + v.slice(0, 80));
		} catch (e) { errEl.textContent = "Too much data for one QR code - shorten the text."; canvas.width = canvas.height = 0; }
	}
	text.addEventListener("input", generate);
	ec.addEventListener("change", generate);

	const ecLabel = el("label", "rv-field-label", "Error correction"); ecLabel.htmlFor = ec.id;
	const top = el("div", "rv-trow"); top.append(ecLabel, ec, dlBtn);
	s.append(text, top, errEl, canvas);
	generate();
}
